import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const lostReasonApi = createApi({
  reducerPath: "lostReasonApi",
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}LostReason/`),

  endpoints: (builder) => ({
    getAllLostReason: builder.query({
      query: () => ({
        url: "GetLostReasons",
        method: "GET",
      }),
    }),

    addLostReason: builder.mutation({
      query: (body) => {
        return {
          url: "AddLostReason",
          method: "POST",
          body,
        };
      },
    }),

    updateLostReason: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateLostReason",
          method: "PUT",
          body,
        };
      },
    }),

    deleteLostReason: builder.mutation({
      query: (id) => ({
        url: `DeleteLostReason?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddLostReasonMutation,
  useGetAllLostReasonQuery,
  useUpdateLostReasonMutation,
  useDeleteLostReasonMutation,
} = lostReasonApi;

export default lostReasonApi.reducer;
